import { getTypographyMetric, getTypographyMetricOverride } from '../../../../../../helpers';
import { useTheme } from 'styled-components';
import { Flex } from 'front-commons/ds/components/Flex';
import { Button, Input } from 'front-commons/ds/components';
import { Typography } from 'hype-ds';
import { PosList } from './components/PosList';
import { ContentProps } from './interfaces';

export function Content({
	disablePosSelecting,
	hasMoreThanFourPos,
	inputProps,
	isSimulated,
	loading,
	posList,
	search,
	handleSeeMore,
	selectedPosId,
	storedPosList,
	onChangePos,
}: ContentProps) {
	const { fontSizes } = useTheme();

	const hasOnlyOnePos = storedPosList.length === 1 && !isSimulated;

	return (
		<>
			{!hasOnlyOnePos && (
				<Input
					name="posFilter"
					placeholder="Buscar CNPJ da farmácia"
					{...{
						...inputProps,
						rightIcon: {
							...inputProps.rightIcon,
							color: '--text-link',
						},
					}}
				/>
			)}

			<PosList
				disabled={disablePosSelecting}
				loading={loading}
				posList={search && posList?.length ? posList : storedPosList}
				posNotFound={posList?.length === 0}
				selectedPosId={selectedPosId}
				onChangePos={onChangePos}
			/>

			{(isSimulated || hasMoreThanFourPos) && (
				<Flex
					as={Button}
					gap="8px"
					position="relative"
					alignItems="center"
					justifyContent="center"
					noShrink
					raw={{
						"[data-component='Typography']": { display: 'inline' },
						"[data-header-text='Content-metric-1']": {
							fontSize: getTypographyMetricOverride(fontSizes['16']),
							lineHeight: getTypographyMetricOverride(fontSizes['24']),
						},
					}}
					onClick={handleSeeMore}
					variant="none"
				>
					<Typography
						data-header-text="Content-metric-1"
						textAlign="inherit"
						fontSize={getTypographyMetric(fontSizes['16'])}
						fontWeight="600"
						lineHeight={getTypographyMetric(fontSizes['24'])}
						color="--hympar-blue-700"
					>
						Ver mais
					</Typography>
				</Flex>
			)}
		</>
	);
}
